import {useSignals} from '@preact/signals-react/runtime'
import {useQueryClient} from '@tanstack/react-query'
import React, {useMemo, useRef} from 'react'
import {HTTP_STATUS_OK} from '../../../Constants'
import {QueryKeyManager} from '../../../query-manager/QueryKeysManager'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {useAuth} from '../../authentication/AuthProvider'
import {useAssignPatient} from '../../user-property/query-keys/UserPropertyQueryManager'
import {UserPropertyType} from '../../user-property/UserPropertyConstants'
import {generalPractitionerInformationList} from './StyledDetailInformationConstants'
import StyledDetailInformationSection from './StyledDetailInformationSection'
import {usePatientContext} from './StyleDetailInformationWrapper'

const StyledGeneralPractitionerInformationSection = () => {
    useSignals()
    const {user} = useAuth()
    const sectionRef = useRef()
    const {currentViewedUser} = usePatientContext()

    const {mutateAsync: assignPatientToGeneralPractitioner} = useAssignPatient(
        UserPropertyType.generalPractitioner,
        user?.id,
    )

    const queryClient = useQueryClient()

    const {patientKeys} = QueryKeyManager(QueryKeyTypes.patient, user?.id)

    const patientQueryKeys = useMemo(() => {
        return patientKeys.detail({id: currentViewedUser?.id})
    }, [patientKeys, currentViewedUser?.id])

    const handleOnSubmit = async data => {
        let toPostData = {
            ...data?.generalPractitioner,
            id: data?.id || null,
            userId: currentViewedUser?.id,
        }

        const response = await assignPatientToGeneralPractitioner(toPostData)

        if (response === HTTP_STATUS_OK) {
            const {generalPractitionerKeys} = QueryKeyManager(
                QueryKeyTypes.generalPractitioner,
                user?.id,
            )

            queryClient.invalidateQueries(generalPractitionerKeys.pattern())
            queryClient.invalidateQueries(patientQueryKeys)
            sectionRef.current.onSuccess(true)
        }
    }

    return (
        <React.Fragment>
            <div className="col-12 p-0">
                <StyledDetailInformationSection
                    ref={sectionRef}
                    data={currentViewedUser}
                    dataList={generalPractitionerInformationList}
                    hideLockButton={true}
                    hideRevertButton={true}
                    onSubmit={handleOnSubmit}
                />
            </div>
        </React.Fragment>
    )
}

export default StyledGeneralPractitionerInformationSection
